import FeaturedOffers from 'components/RwdBasket/RwdBasketLayout/BIBenefits/FeaturedOffers/FeaturedOffers';
import { withFeaturedOffersProps } from 'viewModel/rwdBasket/FeaturedOffers/withFeaturedOffersProps';
const ConnectedFeaturedOffersProps = withFeaturedOffersProps(FeaturedOffers);

export default ConnectedFeaturedOffersProps;
